module.exports = __webpack_public_path__ + "static/img/logo.03bebb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shaoxing/logo.png
// module id = Vs9e
// module chunks = 71